import React from "react"
import Layout from "../components/layout"
import Img from "gatsby-image"
import MoreEvents from "../components/more-events"
import { graphql } from "gatsby"
import SEO from "../components/seo"
import EventMap from "../components/event-map"

export default ({ data }) => {
    const event = data.markdownRemark
    const coord = event.frontmatter.eventMap.slice((event.frontmatter.eventMap.indexOf('[') + 1),event.frontmatter.eventMap.indexOf(']')).split(',').reverse().map(Number)

    return (
        <Layout>
            <SEO title={event.frontmatter.title} />
            <div className="container-fluid">
            <h1 className="text-center mt-3">{event.frontmatter.title}</h1>
                <div className="row">
                    <div className="col-md">
                        <p className="text-center">{event.frontmatter.eventDate}, {event.frontmatter.eventTime} | {event.frontmatter.eventLocation}</p>
                        {typeof window !== 'undefined' &&
                            <EventMap
                                position={coord}
                                markerText={event.frontmatter.eventLocation}
                            />
                        }
                        <div className="row m-3" dangerouslySetInnerHTML={{ __html: event.html }} />
                    </div>
                    <div className="col-md">
                        <Img sizes={event.frontmatter.featuredImage.childImageSharp.fluid} className="mt-3"></Img>
                    </div>
                </div>
            </div>
            <MoreEvents />
        </Layout>
    )
}

export const query = graphql`
    query($slug: String!) {
        markdownRemark(fields: { slug: { eq: $slug } }) {
        html
        frontmatter {
            title
            postedDate(formatString: "Do MMM Y")
            eventDate(formatString: "Do MMM Y")
            eventTime
            eventLocation
            eventMap
            featuredImage {
                childImageSharp {
                    fluid(maxWidth: 1000) {
                        ...GatsbyImageSharpFluid_noBase64
                    }
                }
            }
        }
        }
    }
`